import React, { Component } from "react";
import {
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";
import {
  createRoomType,
  getRoomTypeList,
  editRoomTypeById,
  updateRoomType,
  removeRoomType,
} from "../../Endpoint/Admin/index";
import BranchAssignment from "../../components/Common/BranchAssignment";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, StatCard, StatRow, Table, Btn,
} from "../../components/Console/ConsoleUI";
import { toast } from "react-toastify";

import { AvForm, AvField } from "availity-reactstrap-validation";
import { canWrite } from "../../services/PermissionService";

/**
 * Room types — the rate card behind every room, and the "Room types" half of
 * console screen C2·07 (Room manager).
 *
 * Same create / update / remove calls and the same branch price overrides as
 * before; only the presentation moved to the console kit.
 */

/** Segmented pill row that navigates, matching the design's Room-types toggle. */
const NavPills = ({ items, active }) => (
  <div style={{ display: "flex", padding: 4, borderRadius: 21, background: "#efe2ce" }}>
    {items.map((i) => (
      <Link
        key={i.to}
        to={i.to}
        style={{
          padding: "8px 16px", borderRadius: 17, fontSize: 14, textDecoration: "none",
          background: i.to === active ? C.brown : "transparent",
          color: i.to === active ? "#fff" : C.taupe,
        }}
      >
        {i.label}
      </Link>
    ))}
  </div>
);

/** Compact row action, the console equivalent of the old btn-primary cell. */
const RowBtn = ({ tone, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    style={{
      height: 32, padding: "0 14px", borderRadius: 16, fontSize: 13,
      fontFamily: "inherit", cursor: "pointer",
      border: tone === "danger" ? "none" : `1px solid ${C.border}`,
      background: tone === "danger" ? C.red : "#fff",
      color: tone === "danger" ? "#fff" : C.brown,
    }}
  >
    {children}
  </button>
);

/** A real submit button, so AvForm validation still runs on click. */
const SUBMIT_STYLE = {
  display: "inline-flex", alignItems: "center", justifyContent: "center",
  height: 42, padding: "0 22px", borderRadius: 21, fontSize: 14,
  fontFamily: "inherit", cursor: "pointer", border: "none",
  background: C.brown, color: "#fff",
};

class FormElements extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      updatemodal: false,
      modal: false,
      type: "",
      amount: "",
      discount: "",
      additionalCharges: "",
      noOfRooms : "",
      roomTypeId: null,
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
      success: {},
      breadcrumbItems: [
        { title: "", link: "#" },
        { title: "", link: "#" },
      ],
      customchk: true,
      toggleSwitch: true,
      tableData: {
        columns: [
          {
            label: " Type",
            field: "type",
            sort: "asc",
            width: 60,
          },
          {
            label: " Amount ",
            field: "amount",
            sort: "asc",
            width: 60,
          },

          {
            label: "Discount",
            field: "discount",
            sort: "asc",
            width: 60,
          },
          {
            label : "Totoal No Of Rooms",
            field : "noOfRooms",
            sort : "asc",
            width : 60,
          },
          {
            label: "AdditionalCharges",
            field: "additionalCharges",
            sort: "asc",
            width: 60,
          },

          ...(canWrite() ? [{
            label: "Update",
            field: "update",
            sort: "asc",
            width: 100,
          }] : []),

          ...(canWrite() ? [{
            label: "Remove",
            field: "remove",
            sort: "asc",
            width: 100,
          }] : []),
        ],
        rows: [],
      },
    };
    this.reader = new FileReader();
    this.handleChange = this.handleChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);

    this.updatetoggle = this.updatetoggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal,
      type: "",
      amount: "",
      discount: "",
      noOfRooms : "",
      additionalCharges: "",
      roomTypeId: "",
      branchIds: [],
      excludedBranchIds: [],
      branchOverrides: [],
    });
  }
  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();
    const userObject = {
      type: this.state.type,
      amount: this.state.amount,
      discount: this.state.discount,
      noOfRooms : this.state.noOfRooms,
      additionalCharges: this.state.additionalCharges,
      roomTypeId: this.state.roomTypeId,
      branchIds: this.state.branchIds || [],
      excludedBranchIds: this.state.excludedBranchIds || [],
      branchPriceOverrides: this.state.branchOverrides || [],
    };

    if (this.state.roomTypeId == "" || this.state.roomTypeId == null) {
      createRoomType(userObject)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                type: "",
                amount: "",
                discount: "",
                noOfRooms : "",
                additionalCharges: "",
                roomTypeId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("RoomType added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateRoomType(userObject)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                roomTypeId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Room Type updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }
  getALlluser() {
    getRoomTypeList().then((result) => {
      this.setState({
        isLoaded: true,
        items: result.data,
        tableData: {
          ...this.state.tableData,
          rows: result.data,
          list: result.data.map((x) => {
            x.update = canWrite() ? (
              <RowBtn onClick={() => this.editRoomType(x._id.toString(), x)}>
                Update
              </RowBtn>
            ) : null;
            x.remove = canWrite() ? (
              <RowBtn tone="danger" onClick={() => this.removeRoomstype(x._id.toString())}>
                Remove
              </RowBtn>
            ) : null;

            return x;
          }),
        },
      });
    });
  }
  removeRoomstype(id) {
    removeRoomType(id)
      .then((results) => {
        toast.success("Room Type removed successfully");
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }
  componentDidMount() {
    this.getALlluser();
  }

  editRoomType(id) {
    editRoomTypeById(id)
      .then((results) => {
        this.setState({
          type: results.data.type,
          amount: results.data.amount,
          discount: results.data.discount,
          noOfRooms : results.data.noOfRooms,
          additionalCharges: results.data.additionalCharges,
          roomTypeId: results.data._id,
          branchIds: (results.data.branchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          excludedBranchIds: (results.data.excludedBranchIds || []).map((b) =>
            b && b._id ? b._id : String(b)
          ),
          branchOverrides: results.data.branchPriceOverrides || [],
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  /** Money for the console tables — plain, no cents on a rate card. */
  money(n) {
    return `$${Number(n || 0).toLocaleString()}`;
  }

  /**
   * Display columns, derived from the permission-gated column list in state so
   * Update / Remove still appear only for a writer.
   */
  consoleColumns() {
    const render = {
      type: (x) => (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <span
            className="ms"
            style={{
              width: 44, height: 44, borderRadius: 12, background: C.iconTint,
              color: C.brown, display: "grid", placeItems: "center", fontSize: 21,
            }}
          >
            king_bed
          </span>
          <div>
            <div style={{ fontSize: 15, color: C.ink }}>{x.type || "—"}</div>
            <div style={{ fontSize: 12, color: C.taupeLight }}>
              {x.noOfRooms || 0} unit{x.noOfRooms === 1 ? "" : "s"}
            </div>
          </div>
        </div>
      ),
      amount: (x) => (
        <span style={{ fontSize: 15, fontWeight: 500, color: C.ink }}>{this.money(x.amount)}</span>
      ),
      discount: (x) => (
        <span style={{ color: C.taupe }}>{x.discount ? `${x.discount}%` : "—"}</span>
      ),
      noOfRooms: (x) => <span style={{ color: C.ink }}>{x.noOfRooms || 0}</span>,
      additionalCharges: (x) => (
        <span style={{ color: C.taupe }}>
          {x.additionalCharges ? this.money(x.additionalCharges) : "—"}
        </span>
      ),
      update: (x) => x.update,
      remove: (x) => x.remove,
    };

    // The stored labels carry a typo and a run-together word; the display
    // labels are cleaned up here rather than in state, which the API writes to.
    const label = {
      amount: "Rate",
      noOfRooms: "Units",
      additionalCharges: "Extra charges",
    };

    return this.state.tableData.columns.map((c) => ({
      key: c.field,
      label: label[c.field] || c.label.trim(),
      render: render[c.field] || ((x) => x[c.field]),
    }));
  }

  render() {
    const { items } = this.state;
    const types = items || [];
    const units = types.reduce((s, t) => s + Number(t.noOfRooms || 0), 0);
    const rates = types.map((t) => Number(t.amount || 0)).filter((n) => n > 0);
    const avgRate = rates.length
      ? Math.round(rates.reduce((s, n) => s + n, 0) / rates.length)
      : 0;
    const topRate = rates.length ? Math.max.apply(null, rates) : 0;

    return (
      <ConsolePage
        title="Room types"
        actions={
          <React.Fragment>
            <NavPills
              active="/RoomType"
              items={[
                { to: "/Room", label: "Rooms" },
                { to: "/RoomType", label: "Room types" },
                { to: "/Booking", label: "Bookings" },
                // Routed but previously linked from nowhere.
                { to: "/RoomCancel", label: "Cancellations" },
              ]}
            />
            {canWrite() && (
              <Btn icon="add" onClick={this.toggle}>
                New room type
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={`con-modal ${this.props.className || ""}`}
          size="lg"
          scrollable
          contentClassName="bg-transparent border-0"
        >
          <div style={{ background: "#fdf9f3", borderRadius: 22, padding: 28 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 18 }}>
              <span
                className="ms"
                style={{ fontSize: 24, color: C.brown, background: C.iconTint, padding: 11, borderRadius: 14 }}
              >
                king_bed
              </span>
              <div style={{ flex: 1, fontSize: 20, fontWeight: 500, color: C.ink }}>
                Room type details
              </div>
              <span
                className="ms"
                onClick={this.toggle}
                style={{ fontSize: 22, color: C.taupeLight, cursor: "pointer" }}
              >
                close
              </span>
            </div>
            <AvForm onValidSubmit={this.handleSubmit}>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="name">Type</Label>
                                <AvField
                                  type="text"
                                  value={this.state.type}
                                  onChange={this.handleChange}
                                  id="type"
                                  name="type"
                                  required
                                  errorMessage="Type is required"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="ID">Amount (in usd)</Label>
                                <AvField
                                  type="number"
                                  min={1}
                                  value={this.state.amount}
                                  onChange={this.handleChange}
                                  id="amount"
                                  name="amount"
                                  required
                                  errorMessage="Amount is required"
                                />
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="discount">Discount (in %)</Label>
                                <AvField
                                  type="number"
                                  min={0}
                                  value={this.state.discount}
                                  onChange={this.handleChange}
                                  id="discount"
                                  name="discount"
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="Mac">
                                  AdditionalCharges (in usd)
                                </Label>
                                <AvField
                                  type="number"
                                  min={0}
                                  value={this.state.additionalCharges}
                                  onChange={this.handleChange}
                                  id="additionalCharges"
                                  name="additionalCharges"
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row form>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="noOfRooms">Total No of Rooms</Label>
                                <AvField
                                  type="number"
                                  min={0}
                                  value={this.state.noOfRooms}
                                  onChange={this.handleChange}
                                  id="noOfRooms"
                                  name="noOfRooms"
                                />
                              </FormGroup>
                            </Col>
                            </Row>

                          <BranchAssignment
                            branchIds={this.state.branchIds}
                            excludedBranchIds={this.state.excludedBranchIds}
                            overrides={this.state.branchOverrides}
                            priceFields={[
                              { key: "amount", label: "Amount" },
                              { key: "discount", label: "Discount" },
                              { key: "additionalCharges", label: "Additional Charges" },
                            ]}
                            onChange={({ branchIds, excludedBranchIds, overrides }) =>
                              this.setState({
                                branchIds,
                                excludedBranchIds,
                                branchOverrides: overrides,
                              })
                            }
                          />

                          <div style={{ marginTop: 22, display: "flex", justifyContent: "flex-end", gap: 12 }}>
                            <Button
                              type="button"
                              color="link"
                              onClick={this.toggle}
                              style={{ color: C.taupe, textDecoration: "none" }}
                            >
                              Cancel
                            </Button>
                            <button type="submit" style={SUBMIT_STYLE}>
                              Submit
                            </button>
                          </div>
            </AvForm>
          </div>
        </Modal>

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow>
            <StatCard icon="category" value={types.length} label="Room types" />
            <StatCard icon="meeting_room" value={units} label="Units across all types" />
            <StatCard icon="payments" value={this.money(avgRate)} label="Average nightly rate" />
            <StatCard icon="trending_up" value={this.money(topRate)} label="Highest nightly rate" />
          </StatRow>

          <Panel style={{ padding: 0 }}>
            <div
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "16px 22px", borderBottom: `1px solid ${C.panel}`,
              }}
            >
              <div style={{ fontSize: 17, fontWeight: 500, color: C.ink }}>Rate card</div>
              <div style={{ fontSize: 13, color: C.taupeLight }}>
                {types.length} type{types.length === 1 ? "" : "s"}
              </div>
            </div>
            <div style={{ padding: "0 10px" }}>
              <Table
                columns={this.consoleColumns()}
                rows={types}
                empty={this.state.isLoaded ? "No room types yet" : "Loading room types…"}
              />
            </div>
          </Panel>
        </div>
      </ConsolePage>
    );
  }
}

export default FormElements;
